/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionVm
 */
export interface PermissionVm {
    /**
     * 
     * @type {string}
     * @memberof PermissionVm
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionVm
     */
    description?: string | null;
}

export function PermissionVmFromJSON(json: any): PermissionVm {
    return PermissionVmFromJSONTyped(json, false);
}

export function PermissionVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function PermissionVmToJSON(value?: PermissionVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}


